<template lang="html">
  <div class="benefits">
    <NavBar :titleTranslationPath="categoryData.path" :title="categoryData.name" back="back" commune="commune" />
    <Banner />
    <div class="hero" v-if="categoryData.image">
      <img class="hero-image" :src="getCategoryImageUrl(categoryData)" />
    </div>
    <div class="content">
      <div class="benefit-list">
        <div
          class="benefit-entry"
          v-for="benefit in categoryData.benefits"
          :key="benefit.id"
          @click="goBenefit(benefit.id)"
        >
          <img class="benefit-image" :src="getBenefitImageUrl(benefit)" />
          <div class="benefit-title">{{ benefit.venueTitle }}</div>
          <div class="benefit-place">{{ benefit.venuePlace }}</div>
          <div class="benefit-short-description" v-html="getSafeBenefitText(benefit.benefitShortDescription)"></div>
          <div v-if="benefit.benefitVoidingType!=2" class="benefit-voiding-type">
            {{translate(`benefitsDetail.coupon.voidable.short.type${benefit.benefitVoidingType}`)}}
          </div>
        </div>
      </div>
    </div>
    <TabBar />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Banner from '@/components/Banner.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import i18next from 'i18next';
import RemoteAssets from '@/app/utils/RemoteAssets';

export default {
  components: {
    NewTranslation,
    NavBar,
    TabBar,
    Banner,
  },
  data() {
    return {
      dateOfWeek: 0,
      categoryId: this.$route.query.categoryId,
      categoryName: this.$route.query.categoryName,
      scopeSelected: this.$route.query.scopeSelected,
    };
  },
  mounted() {
    let dayStartingSunday = this.$moment().day();
    this.dateOfWeek = dayStartingSunday ? --dayStartingSunday : 6;
    if (this.categoryName === 'favorites') {
      this.$store.dispatch('loadFavorites');
    }
  },
  methods: {
    goBenefit(benefit) {
      this.$router.push({
        name: this.$namedRoutes.benefitsDetail,
        query: {
          benefitId: benefit,
        },
      });
    },
    goFavorites() {
      this.$router.push({
        name: this.$namedRoutes.benefitsCategory,
        query: {
          categoryName: 'favorites',
        },
        params: {
          pageData: {
            id: 'favorites',
            name: i18next.t('benefitsCategory.favoritesTitle'),
            image: null,
            count: 0,
          },
        },
      });
    },
    getCategoryImageUrl(benefit) {
      return RemoteAssets.benefitCategoryImageUrl(benefit.image);
    },
    getBenefitImageUrl(benefit) {
      if (benefit.venueImage) {
        return RemoteAssets.benefitImageUrl(benefit.venueImage);
      } else if (benefit.externalImg) {
        return benefit.externalImg;
      }
      return '';
    },    
    translate(path, params) {
      return i18next.t(path, params);
    },
    getSafeBenefitText(value) {
      if (value) {
        const resultParsed = `<div class="benefit-safe-text-wrapper">${value}</div>`;
        return resultParsed;
      }
      return '';
    }
  },
  computed: {
    categoryData() {
      if (this.categoryName === 'favorites') {
        return {
          path: 'benefitsCategory.favorites.title',
          benefits: this.benefitsOfFavorites,
        };
      } else if (this.$store.getters.benefitCategories.length > 0) {
        // const catAsNum = parseInt(this.$route.query.categoryId, 10);
        const catName = this.$route.query.categoryName;
        const scopeSelected = this.$route.query.scopeSelected;
        const benefitsCategory = this.$store.getters.benefitCategoryByNameData(catName, scopeSelected)[0];
        const tmpBenefits = this.$store.getters.benefitsOfCategory(benefitsCategory.name, scopeSelected)
        return {
          name: benefitsCategory.name,
          image: benefitsCategory.image,
          benefits: tmpBenefits
        };
      }
      return {path: '', benefits: []};
    },
    ...mapGetters(['benefits', 'benefitCategories', 'favorites', 'benefitsOfFavorites', 'benefitsOfPreferences']),
  },
};
</script>

<style lang="sass" scoped>
.benefits
	padding-bottom: 100px
.hero
	width: 100%
	height: 250px
	&-image
		width: 100%
		height: 100%
		object-fit: cover
		object-position: center center
		background-color: #ccc

.content
	padding: 20px


.option
	&-list
		display: flex
		padding-bottom: 20px
	&-button
		background-color: #1DB2D1
		border-radius: 20px
		padding: 10px 20px
		color: #fff
		width: 100%
		position: relative
		svg
			height: 10px
			position: absolute
			right: 20px
			top: 16px
		& + .option-button
			margin-left: 20px

.benefit
	// &-list
	&-entry
		border-top: 1px solid #F4F4F6
		padding-top: 20px
		padding-bottom: 20px
		color: #454F63
	&-image
		width: 100%
		height: 250px
		max-width: 100%
		object-fit: cover
		object-position: center center
	&-rating
		display: flex
		margin: 7px -4px 0
		&-star
			height: 20px
			width: 21px
			object-fit: contain
			margin: 0 3px
		&-full
			color: #D1701D
		&-empty
			color: #454F63
		&-amount
			color: #1DB2D1
			margin-left: 5px
	&-title
		margin-top: 20px
		font-weight: bold
	&-place
		margin-top: 4px
	&-short-description
		margin-top: 4px
	&-voiding-type
		margin-top: 4px
	&-openinghour
		margin-top: 10px
	&-distance
		margin-top: 25px
		display: flex
		align-items: center
		&-icon
			width: 32px
			height: 32px
			padding: 7px 7px 5px 5px
			border-radius: 50px
			color: #1DB2D1
			border: 1px solid #1DB2D1
			margin-right: 10px
		// &-text
			// text-decoration: underline
</style>
<style lang="scss">
.benefit-safe-text-wrapper {
	& > p {
		margin-top: 0px;
		margin-bottom: 0px;
	}
}
</style>
